import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';

import React from 'react';

import { Text, TextType } from 'ui-components/components/text';
import { FlexRow } from 'ui-components/components/flex';

import { useHomePageOnboardContext } from '../../../../home-page-onboard-context';

import { messages } from '../../messages';
import style from '../../onboard-cards.module.less';

export const OrderImportCardBody = () => {
  const { hasConnectedStore, isOrderImportComplete } = useHomePageOnboardContext();
  const { sellerStoreToRender } = useHomePageOnboardContext();

  const originalDate = new Date(sellerStoreToRender.createDateUtc);
  const formattedDate = originalDate.toLocaleString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
  });

  const ConnectedStore = () => {
    return (
      <FlexRow className={style.date}>
        <Text textType={TextType.Paragraph} value={messages.connected} />
        <FontAwesomeIcon className={style.dot} icon={faCircle} />
        <Text textType={TextType.Paragraph} value={formattedDate} />
      </FlexRow>
    );
  };

  const completeBody = hasConnectedStore ? (
    <ConnectedStore />
  ) : (
    <Text shouldTruncate textType={TextType.Paragraph} value={messages.orderImportCardCompleteOrders} />
  );

  return !isOrderImportComplete ? <Text textType={TextType.Paragraph} value={messages.orderImportCardGuidingText} /> : completeBody;
};
